module.exports = __webpack_public_path__ + "assets/img/logo_pc.090e3cb7.png";